<template>
  <v-dialog v-model="propDialogo" width="500px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="clearFields(); $emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            {{ this.propNuevo ? "NUEVA" : "EDITAR" }} CATEGORIA
          </h1>
        </div>
        <div style="padding-left: 10px; padding-right: 10px; margin: 10px">
          <div>
          </div>
        </div>
        <div class="line" style="padding: 10px; margin: 10px; border-radius: 5px">
          <!-- -------------------- -->
          <div>
      
            <div>
              <h2>Título Categoria</h2>
              <v-text-field v-model="formulario.titulo" outlined dense placeholder="Ingrese título" />
            </div>
            <v-btn block color="#0D47A1" style="color: white" @click="propNuevo ? crearCategoria() : actualizarCurso()">
              <h2>GUARDAR</h2>
            </v-btn>
          </div>
          <!-- -------------------- -->
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    propCrear: { type: Function },
    propActualizar: { type: Function },
    propNuevo: { type: Boolean },
    propDialogo: { type: Boolean },
    propCategoria: { type: Object }
  },
  data() {
    return {
      formulario: {
        id: '',
        titulo: '',
      },
      imagePreview: null,
      imagePreviewOld: null,
      sms: "",
    };
  },
  mounted() { },
  watch: {
    propCategoria() {
      this.clearFields()
      this.setFields()
    }
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formulario.imagen = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },

    async crearCategoria() {
      if (!this.formulario.titulo) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("titulo", this.formulario.titulo.toLocaleUpperCase());
      try {
        const result = await this.propCrear(form); // Enviamos como formulario
        const _result = result.data
        if (_result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    async actualizarCurso() {
      if (!this.formulario.titulo) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("id", this.formulario.id);
      form.append("titulo", this.formulario.titulo);
      try {
        const result = await this.propActualizar(form); // Enviamos como formulario
        if (result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
        
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    splitDateTime(dateTime) {
      const [date, time] = dateTime.split(", "); // Divide en fecha y hora
      const [year, month, day] = date.split("/"); // Divide la fecha en partes
      const [hour, minute, second] = time.split(":"); // Divide la hora en partes

      return {
        year,
        month,
        day,
        hour,
        minute,
        second,
      };
    },
    setFields() {
      this.formulario.id = this.propCategoria.id
      this.formulario.titulo = this.propCategoria.titulo
    },
    clearFields() {
      this.formulario.titulo = ''
      this.formulario.id = ''
    },
    genDate() {
      const options = {
        timeZone: "America/Guayaquil", // Configura la zona horaria de Guayaquil
        hour12: false, // Usar formato de 24 horas
      };

      const now = new Date();

      // Usar toLocaleString para obtener la fecha en la zona horaria especificada
      const year = now.toLocaleString("es-EC", { ...options, year: "numeric" });
      const month = String(
        now.toLocaleString("es-EC", { ...options, month: "2-digit" })
      ).padStart(2, "0");
      const day = String(
        now.toLocaleString("es-EC", { ...options, day: "2-digit" })
      ).padStart(2, "0");
      const hours = String(
        now.toLocaleString("es-EC", { ...options, hour: "2-digit" })
      ).padStart(2, "0");
      const minutes = String(
        now.toLocaleString("es-EC", { ...options, minute: "2-digit" })
      ).padStart(2, "0");
      const seconds = String(
        now.toLocaleString("es-EC", { ...options, second: "2-digit" })
      ).padStart(2, "0");
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped></style>
